<template>
    <div>
        <quillEditor
            ref="myQuillEditor"
            :content="description"
            :options="editorOption"
            @change="onEditorChange($event)"
            class="roma-editor"
        >
        </quillEditor>
    </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
export default {
    props: {
        placeholder: {
            type: String
        },
        data: {},
        updateMode: {
            type: Object
        }
    },
    data() {
        return {
            description: this.data,
            editorOption: {
                placeholder: this.placeholder ? this.placeholder : ""
            }
        };
    },
    components: {
        quillEditor
    },
    mounted() {
        this.$refs.myQuillEditor.quill.getModule("toolbar").addHandler("image",  () => {});
    },
    methods: {
        onEditorChange({ html }) {
            this.$emit('changeData', html);            
        }
    }
};
</script>

<style lang="scss">

.roma-editor {
    border: 1px solid lightgray;
    display: flex;
    flex-direction: column;
    .ql-formats {
        .ql-link,
        .ql-video,
        .ql-image,
        .ql-font {
            display: none;
        }
    }
    // overflow: hidden;
    .ql-editor {
        padding: 1.5rem;
        &.ql-blank::before {
            left: 1.5rem;
        }
    }
    .ql-toolbar {
        background-color: #f5f5f5 !important;
        display: flex;
        flex-wrap: wrap;
    }
    .ql-container {
        height: auto;
    }
    .ql-toolbar,
    .ql-container {
        border: 0;
    }
}
.custom-wyswyg {
    height: 200px;
    .v-card {
        height: 100%;
        display: flex;
        flex-direction: column-reverse;
        overflow: hidden;
        .v-toolbar {
            justify-content: flex-end;
        }
        .tiptap-vuetify-editor__content {
            flex: 1;
        }
    }
}
</style>
